
const isProd = process.env.NODE_ENV === 'production';
const istest = process.env.NODE_ENV === 'test';
let API_HEADER = ''
let DataApiUrl = ''
let LOGIN_HEADER=''
let USER_HEADER=''
let TASK_HEADER=''
let EVENT_HEADER=""
if (isProd) {
    // LOGIN_HEADER = 'http://sso.xyabcd.com/ssoauth';
    API_HEADER = planConfig.API_HEADER || 'http://userc.xyabcd.com'
    DataApiUrl = planConfig.DataApiUrl || "http://dataapi.xyabcd.com/datacenterservice"
    USER_HEADER= planConfig.USER_HEADER || 'http://userc.xyabcd.com'
    TASK_HEADER= planConfig.TASK_HEADER || 'http://taskc.xyabcd.com'
    EVENT_HEADER=planConfig.EVENT_HEADER || 'http://eventc.xyabcd.com/'
} else if (istest) {
    API_HEADER= 'http://test.plancenter.com'
    DataApiUrl = "http://192.168.0.226:30005/datacenterservice"
    USER_HEADER= 'http://test.usercenter.com'
    TASK_HEADER= 'http://test.taskcenter.com'
    EVENT_HEADER= 'http://test.eventcenter.com'
} else {

    API_HEADER=planConfig.API_HEADER ||  "http://test.plancenter.com"
    DataApiUrl =planConfig.DataApiUrl ||  "http://192.168.0.226:30005/datacenterservice"
    USER_HEADER= planConfig.USER_HEADER || "http://test.usercenter.com"
    TASK_HEADER=planConfig.TASK_HEADER ||  "http://test.taskcenter.com"
    EVENT_HEADER= 'http://test.eventcenter.com'
}
export default {
    API_HEADER,
    DataApiUrl,
    LOGIN_HEADER,
    USER_HEADER,
    TASK_HEADER,
    EVENT_HEADER
}